import debugTools from "../evaluation/debug";

const sanitizeFeed = (feed) => {
    debugTools.debug("Sanitizing feed");
    feed = feed.data || feed;

    if (Array.isArray(feed)) {
        feed = {
            targets: feed,
        };
    }

    feed.targets.forEach((target) => {
        if (typeof target.config === "string") {
            target.config = JSON.parse(target.config);
        }

        if (typeof target.condition === "string") {
            target.condition = JSON.parse(target.condition);
        }

        if (target.experiments) {
            target.experiments.forEach((experiment) => {
                experiment.buckets.forEach((bucket) => {
                    if (typeof bucket.config === "string") {
                        bucket.config = JSON.parse(bucket.config);
                    }
                });
            });
        }

        if (target.globalExperiments) {
            target.globalExperiments.forEach((experiment) => {
                experiment.buckets.forEach((bucket) => {
                    if (typeof bucket.config === "string") {
                        bucket.config = JSON.parse(bucket.config);
                    }
                });
            });
        }
    });
    debugTools.debug("Successfully sanitized feed");

    return feed;
};

export default sanitizeFeed;
